import { useEffect, useState } from 'react'

import { Typography, Grid, FormControl, TextField, Button, FormHelperText, InputAdornment, Select, MenuItem, InputLabel } from '@material-ui/core'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { withStyles } from '@material-ui/core/styles'
import validator from 'validator'

import styles from '../dashboardStyles'
import Vector from '../../../../../ui-assets/Vector.svg'
import { httpRequest } from '../../../../../ui-utils/api'
import { apiUrl } from '../../../../../ui-utils/apiConfig'

const CallerInfo = ({
    classes,
    customerEmail,
    customerLocation,
    customerState,
    customerPortfolios,
    customerName,
    errType: err,
    errorMsg,
    dispatch,
    handleName,
    handleEmail,
    customerPhoneNumber,
    handlePhoneNumber,
    handleLocation,
    handleStateName,
    handleSelectedEmail
}) => {

    const [editMode, setEditMode] = useState(false)
    const [errType, setErrType] = useState(0)
    const [saveButst, setSaveButst] = useState(false)

    const portfolio = customerName || customerEmail || customerPhoneNumber || customerLocation || customerState

    const handleEditClick = () => {
        setEditMode(!editMode)
    }

    useEffect(() => {
        if (err) {
            setErrType(err)
        }
    }, [err])

    const handleCreateNewCustomer = async () => {
        let isOk = true

        const validateField = (field, errorMsgs, errorType) => {
            if (!field.trim()) {
                isOk = false
                setErrType(errorType)
                dispatch({
                    type: 'SET_ERROR',
                    payload: errorMsgs
                })
            } else {
                setErrType(errorType)
                dispatch({
                    type: 'SET_ERROR',
                    payload: ''
                })
            }
        }

        validateField(customerName, 'Enter the name', 1)
        validateField(customerLocation, 'Enter the location', 3)
        validateField(customerState, 'Enter the State name', 4)

        if (!validator.isEmail(customerEmail)) {
            isOk = false
            setErrType(5)
            dispatch({
                type: 'SET_ERROR',
                payload: 'E-Mail is Not Valid'
            })
        }

        if (customerPhoneNumber.length !== 10) {
            isOk = false
            setErrType(2)
            dispatch({
                type: 'SET_ERROR',
                payload: 'Enter the valid phone number'
            })
        }

        if (isOk) {
            const customerdetails = {
                name: customerName,
                phones: [parseInt(customerPhoneNumber)],
                other: {},
                emails: [customerEmail],
                address: { location: customerLocation, state: customerState },
                notes: "String",
                created_by: Number(localStorage.getItem('user_id1'))
            }

            try {
                const callerInformation = await httpRequest({
                    endPoint: `${apiUrl.unregisteredCustomer}`,
                    method: "post",
                    instance: "instanceOne",
                    requestBody: customerdetails,
                })

                if (callerInformation.success) {
                    setSaveButst(true)

                    dispatch({
                        type: 'SET_ERROR',
                        payload: ''
                    })
                }
                // Dev Srini 25/10/24
                else {
                    console.log('Error in unRegistered customer API', callerInformation)
                }

            }
            catch (error) {
                console.log('Error in unRegistered customer API', error)
            }
        }
    }

    return (
        <div style={{ flex: '10%', textAlign: 'center' }}>
            <div style={{
                display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '30px', marginTop: '20px'
            }}>
                <img src={Vector} alt='Caller Icon' />
                <Typography className={classes.callerInfoText} style={{ marginRight: '30px' }}>Caller Info</Typography>

                {

                    <button className={classes.editButtonLayout} onClick={handleEditClick}>
                        <span className={classes.editText}>Edit</span>
                    </button>
                }
            </div>

            <div>
                <Typography className={classes.layout2text} style={{ margin: '0px 0px 10px -50px' }}>
                    Number of portfolio's - {customerPortfolios.length}
                </Typography>
            </div>

            <Grid style={{ marginBottom: '16px' }} >
                {/* srini - 14/11/24 */}
                <form autoComplete="off">
                    <input type="text" name="prevent-autocomplete" style={{ display: 'none' }} autoComplete="off" />
                    <Grid item >
                        <Typography className={classes.formLabel} style={{ marginRight: '190px' }} >Name</Typography>
                        <FormControl>
                            <TextField
                                name="unique-name-field"
                                id="name-field" // srini - 12/12/24
                                InputProps={{
                                    autoComplete: 'off-xyz',
                                    style: {
                                        width: '242px ',
                                        height: '45px ',
                                        backgroundColor: '#0B1420 ',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular',
                                        fontSize: '12px',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        lineHeight: '20px',
                                        paddingLeft: '10px',
                                    }
                                }}
                                value={customerName}
                                onChange={e => handleName(e)}
                                autoComplete="off-xyz"
                            />
                            {errType === 1 &&
                                <FormHelperText className={classes.errtxt} id="component-error-text">{errorMsg}</FormHelperText>
                            }
                        </FormControl>
                    </Grid>
                </form>


                <Grid item>
                    <Typography className={classes.formLabel} style={{ marginRight: '190px' }}>Email</Typography>
                    {
                        editMode ? (
                            <>
                                <FormControl className={`${classes.focused}`}
                                    style={{
                                        width: '242px',
                                        height: '49px',
                                        flexShrink: 0,
                                        borderRadius: '4px',
                                        background: '#0B1420',
                                    }}
                                >
                                    <InputLabel></InputLabel>

                                    <Select
                                        value={customerEmail}
                                        onChange={(e) => {
                                            const selectedEmail = e.target.value
                                            const selectedEle = customerPortfolios.find(ele => ele.email === selectedEmail)
                                            handleSelectedEmail(selectedEle)
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    backgroundColor: '#131E2E',
                                                    marginTop: '10px',
                                                    maxHeight: '140px'
                                                },
                                            },
                                        }}
                                        IconComponent={() => <ArrowDropDownIcon style={{ color: 'white' }} />}
                                        renderValue={(selectedValue) => (
                                            <span
                                                style={{
                                                    color: '#999',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    lineHeight: '20px',
                                                    paddingRight: '50px',
                                                    paddingLeft: '10px'
                                                }}
                                            >{selectedValue}</span>
                                        )}
                                        disabled={!editMode}
                                    >
                                        {customerPortfolios.map(ele => (
                                            <MenuItem
                                                key={ele.id}
                                                value={ele.email}
                                                style={{
                                                    color: '#999',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    lineHeight: '20px',
                                                }}
                                            >{ele.email}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>
                        ) : (
                            <>
                                {/* srini - 14/11/24 */}
                                <form autoComplete="off">
                                    <input type="text" name="prevent-autocomplete" style={{ display: 'none' }} autoComplete="off" />
                                    <FormControl>
                                        <TextField
                                            name="unique-name-field"
                                            id="email-field" // srini - 12/12/24
                                            InputProps={{
                                                autoComplete: 'off-xyz',
                                                style: {
                                                    width: '242px ',
                                                    height: '45px ',
                                                    backgroundColor: '#0B1420 ',
                                                    flexShrink: 0,
                                                    color: '#999',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '20px',
                                                    paddingLeft: '10px',
                                                }
                                            }}
                                            value={customerEmail}
                                            onChange={e => handleEmail(e)}
                                            autoComplete='off-xyz'
                                        />

                                        {errType === 5 &&
                                            <FormHelperText className={classes.errtxt} id="component-error-text">{errorMsg}</FormHelperText>
                                        }
                                    </FormControl>
                                </form>
                            </>
                        )
                    }
                </Grid>

                {/* srini - 14/11/24 */}
                <form autoComplete="off">
                    <input type="text" name="prevent-autocomplete" style={{ display: 'none' }} autoComplete="off" />
                    <Grid item>
                        <Typography className={classes.formLabel} style={{ marginRight: '150px' }}>Phone Number</Typography>
                        <FormControl>
                            <TextField
                                name="unique-name-field"
                                id="phone-field" // srini - 12/12/24
                                InputProps={{
                                    autoComplete: 'off-xyz',
                                    startAdornment: <InputAdornment position="start">
                                        <Typography
                                            style={{
                                                color: "#999",
                                                fontFamily: 'cardiuma-regular',
                                                fontSize: '12px',
                                                marginLeft: '10px'
                                            }}>
                                            +91
                                        </Typography>
                                    </InputAdornment>,
                                    style: {
                                        width: '242px ',
                                        height: '45px ',
                                        backgroundColor: '#0B1420 ',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular',
                                        fontSize: '12px',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        lineHeight: '20px',
                                    },
                                    minLength: 10,
                                    maxLength: 10
                                }}
                                value={customerPhoneNumber}
                                onChange={e => handlePhoneNumber(e)}
                                autoComplete='off-xyz'
                            />
                            {errType === 2 &&
                                <FormHelperText className={classes.errtxt} id="component-error-text">{errorMsg}</FormHelperText>
                            }
                        </FormControl>
                    </Grid>
                </form>

                {/* srini - 14/11/24 */}
                <form autoComplete="off">
                    <input type="text" name="prevent-autocomplete" style={{ display: 'none' }} autoComplete="off" />
                    <Grid item>
                        <Typography className={classes.formLabel} style={{ marginRight: '180px' }}>Location</Typography>
                        <FormControl>
                            <TextField
                                name="unique-name-field"
                                id="location-field" // srini - 12/12/24
                                InputProps={{
                                    autoComplete: 'off-xyz',
                                    style: {
                                        width: '242px ',
                                        height: '45px ',
                                        backgroundColor: '#0B1420 ',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular',
                                        fontSize: '12px',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        lineHeight: '20px',
                                        paddingLeft: '10px'
                                    }
                                }}
                                value={customerLocation}
                                onChange={e => handleLocation(e)}
                                autoComplete='off-xyz'
                            />
                            {errType === 3 &&
                                <FormHelperText className={classes.errtxt} id="component-error-text">{errorMsg}</FormHelperText>
                            }
                        </FormControl>
                    </Grid>
                </form>

                {/* srini - 14/11/24 */}
                <form autoComplete="off">
                    <input type="text" name="prevent-autocomplete" style={{ display: 'none' }} autoComplete="off" />
                    <Grid item>
                        <Typography className={classes.formLabel} style={{ marginRight: '190px' }}>State</Typography>
                        <FormControl>
                            <TextField
                                name="unique-name-field"
                                id="state-field" // srini - 12/12/24
                                InputProps={{
                                    autoComplete: "off-xyz",
                                    style: {
                                        width: '242px ',
                                        height: '45px ',
                                        backgroundColor: '#0B1420 ',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular',
                                        fontSize: '12px',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        lineHeight: '20px',
                                        paddingLeft: '10px',
                                    }
                                }}
                                value={customerState}
                                onChange={e => handleStateName(e)}
                                autoComplete="off-xyz"

                            />
                            {errType === 4 &&
                                <FormHelperText className={classes.errtxt} id="component-error-text">{errorMsg}</FormHelperText>
                            }
                        </FormControl>

                    </Grid>
                </form>

                <Grid style={{ marginLeft: '110px', marginTop: '10px' }}>
                    {
                        editMode || portfolio.length > 0 &&
                        <Button

                            disabled={saveButst}
                            className={saveButst ? classes.submitbuttonlayout_dis : classes.submitbuttonlayout} onClick={handleCreateNewCustomer} >
                            <span className={classes.submitbuttontext} style={{ textTransform: 'none' }} > Save </span>
                        </Button>
                    }
                </Grid>

            </Grid>
        </div>
    )
}

export default withStyles(styles)(CallerInfo)